import React from 'react';
import { IVacancyCreateOrEditContext, VacancyCreateOrEditContext } from 'src/features/vacancy/createOrEdit/model';
import { IVacancyCreateOrEditHandle, VacancyCreateOrEdit } from 'src/features/vacancy/createOrEdit/ui';

export const VacancyCreateOrEditProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const viewerRef = React.useRef<IVacancyCreateOrEditHandle>(null);

  const value = React.useMemo<IVacancyCreateOrEditContext>(
    () => ({
      create: (initialValues) => viewerRef.current?.create(initialValues),
      edit: (id) => viewerRef.current?.edit(id),
    }),
    [],
  );

  return (
    <VacancyCreateOrEditContext.Provider value={value}>
      <VacancyCreateOrEdit ref={viewerRef} />
      {children}
    </VacancyCreateOrEditContext.Provider>
  );
};
